module.exports = __webpack_public_path__ + "static/media/bag.487f8cfe.svg";